import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { SHIPMENT_ITEM_BREAKDOWN, } from '../types/shipment-item-breakdown.js';
/**
 * Descriptor for ShipmentItemBreakdown.
 * Path: org/{orgId}/shipment/{shipmentId}/item/{itemId}/breakdown
 */
export const shipmentItemBreakdownDescriptor = {
    name: SHIPMENT_ITEM_BREAKDOWN,
    label: 'Breakdown do item da expedição',
    domain: 'sales',
    collectionPath: 'org/{orgId}/shipment/{shipmentId}/item/{itemId}/breakdown',
    pathPatternKeys: {
        orgId: 'string',
        shipmentId: 'string',
        itemId: 'string',
    },
    version: 1,
    description: 'Size distribution of a shipment line — full ProductVariant + lot per size',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'shipmentItemId', label: 'Item da expedição', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: true },
        { name: 'quantity', label: 'Quantidade', type: 'number', display: 'quantity', required: true },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
    ],
};
//# sourceMappingURL=shipment-item-breakdown.descriptor.js.map